export const RMX_API_URL =
  typeof window !== 'undefined' && window.location.host === import.meta.env.VITE_USE_RMX_API_PROD_WHEN_HOST_EQUALS
    ? import.meta.env.VITE_RMX_PROD_API_URL
    : import.meta.env.VITE_RMX_LOCAL_API_URL;

export const PORTAL_API_URL =
  typeof window !== 'undefined' && window.location.host === import.meta.env.VITE_USE_PORTAL_API_PROD_WHEN_HOST_EQUALS
    ? import.meta.env.VITE_PORTAL_PROD_API_URL
    : import.meta.env.VITE_PORTAL_LOCAL_API_URL;
